import React, { useRef, useState } from "react";

const LogoUploader = ({ logoUrl, onUpload, disabled }) => {
  const fileInputRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) onUpload(file);
  };

  return (
    <div className="relative">
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="hidden"
        ref={fileInputRef}
        disabled={disabled}
      />
      {!logoUrl ? (
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
          className="btn-secondary"
        >
          Upload logo
        </button>
      ) : (
        <div
          className="group relative inline-block"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <img
            src={logoUrl}
            alt="Project logo"
            className="max-h-14 rounded border border-zinc-200 bg-white p-1.5"
          />
          {isHovering && !disabled && (
            <button
              type="button"
              className="absolute inset-0 flex items-center justify-center rounded bg-navy-900/70 text-xs font-medium uppercase tracking-wide text-white"
              onClick={() => fileInputRef.current?.click()}
            >
              Replace
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default LogoUploader;
